import { Link } from "react-router-dom";
import YogaNavBar from "./YogaNavBar";

export default function NatureFlowSignUp () {
    return (
        <>
        <YogaNavBar />
        hi
        </>
    )
}
